<div class="timeline-holder right">
    <div class="content">
      <h2>May - 2020</h2>
      <p>Boldungu  is made available to the public with raving reviews</p>
    </div>
  </div>
